import { Text } from "@mantine/core";
import React from "react";

const MatchEmployeePayslipEmptyState: React.FC = () => (
  <div
    style={{
      height: "324px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "8px",
      padding: "24px",
      borderRadius: "4px",
      border: "solid 1px var(--grey-grey-50)",
      backgroundColor: "var(--background-background)",
    }}
  >
    <div
      style={{
        height: "40px",
        alignSelf: "stretch",
        flexGrow: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: "16px",
        padding: 0,
        alignItems: "center",
      }}
    >
      <Text
        style={{
          width: "150px",
          height: "16px",
          flexGrow: 0,
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: "bold",
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "normal",
          letterSpacing: "0.16px",
          textAlign: "center",
          color: "var(--grey-grey-80)",
        }}
      >
        No employees selected
      </Text>
      <Text
        style={{
          height: "16px",
          alignSelf: "stretch",
          flexGrow: 0,
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: "normal",
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: 1.33,
          letterSpacing: "0.16px",
          textAlign: "center",
          color: "var(--grey-grey-70)",
        }}
      >
        Use the search field above to find an employee
      </Text>
    </div>
  </div>

)


export default MatchEmployeePayslipEmptyState